export default "__VITE_ASSET__DSIdaQLk__"